module.exports = __webpack_public_path__ + "static/scale-model-of-celestial-park-in-richardson-texas-cd93fe45ed5cfc989bf98b593fe8d584.png";